
























import {Component, Vue} from "vue-property-decorator";
import {getRandomFamilyList, RequiemRecord} from "@/data/FamilyData";

const createjs = window['createjs'];

enum AppState {
  DISCLAIMER,
  RUN
}

enum AnimationState {
  LINES_ADD,
  LINES_FADE,
  LINES_DRAG,
  BUBBLE,
  DIGITS
}

@Component({
  components: {},
})
export default class App extends Vue {
  appState: AppState = AppState.DISCLAIMER;
  animationState: AnimationState = AnimationState.BUBBLE;

  run() {
    this.animationState = AnimationState.LINES_ADD;
    this.appState = AppState.RUN;
    this.bubleMC.stop();
    this.stage.removeChild(this.bubleMC);
    (this.$refs['track'] as HTMLAudioElement).play();
    window['track'] = (this.$refs['track'] as HTMLAudioElement);
    const fullNameTime = (this.$refs['track'] as HTMLAudioElement).duration - 85;
    (this.$refs['track'] as HTMLAudioElement).addEventListener('ended',ev=>{
      location.reload(true);
    })
    this.lineContainer = new createjs.Container();
    this.stage.addChild(this.lineContainer);

    (this.$refs['track'] as HTMLAudioElement).addEventListener('timeupdate',ev=>{
      const newLineNumber = Math.floor((ev.target as HTMLAudioElement).currentTime /2.65);
      if(this.lineNumber!==newLineNumber&&this.lineNumber<60){
        this.lineNumber = newLineNumber;
        const sY = this.getRandomLinePoint(),
              eY = this.getRandomLinePoint(),
              direction = (Math.floor(Math.random()+0.5));
        this.lineList.push({mc:this.createLineAnimation(sY,eY,direction),sY:sY,eY:eY,direction:direction});

      }
      const newIndex = Math.floor((ev.target as HTMLAudioElement).currentTime *60/ fullNameTime);
      if(newIndex!==this.requemIndex){
        (this.$refs['names'] as HTMLDivElement).style.opacity = '0';
        setTimeout(()=>{
          this.requemIndex = newIndex;
          (this.$refs['names'] as HTMLDivElement).style.opacity = '1';
        },600)
      }
      if((ev.target as HTMLAudioElement).currentTime>=157.5&&(ev.target as HTMLAudioElement).currentTime<172&&this.animationState===AnimationState.LINES_ADD){
        const containerAlpha = (159.5 - (ev.target as HTMLAudioElement).currentTime)/2;
        this.lineContainer.alpha = containerAlpha;
        if((ev.target as HTMLAudioElement).currentTime>169.2){
          this.transferLines();
        }
      }
      if((ev.target as HTMLAudioElement).currentTime>=172&&(ev.target as HTMLAudioElement).currentTime<196&&this.animationState===AnimationState.LINES_DRAG){
        this.fadeCf = (192 - (ev.target as HTMLAudioElement).currentTime)/21;
      }
      if((ev.target as HTMLAudioElement).currentTime>=201.3&&(ev.target as HTMLAudioElement).currentTime<((this.$refs['track'] as HTMLAudioElement).duration - 70)&&this.animationState!==AnimationState.BUBBLE){
        this.goToBuble();
      }
      this.timeLeast = (ev.target as HTMLAudioElement).duration - (ev.target as HTMLAudioElement).currentTime - 10;
      if((ev.target as HTMLAudioElement).currentTime>322.7&&this.animationState!== AnimationState.DIGITS){
        this.gotoDigits();
      }
    })
  }

  private requeimList:RequiemRecord[] = [];
  private requemIndex = -1;

  private fadeCf = 1;

  private stage:any= null;
  private bubleMC:any = null;
  private digitsContainer = null;
  private lineContainer:any = null;

  private timeLeast:number = 61;

  private decDigits = [];
  private oneDigits = [];
  private gDecDigits = [];
  private gOneDigits = [];

  private lineNumber = -1;

  private lineList = [];

  mounted(){
    this.resizeCanvas()
    window.addEventListener('resize',()=>{
      this.resizeCanvas();
      if(this.digitsContainer) {
        this.digitsContainer.x = this.stage.canvas.width / 2;
        this.digitsContainer.y = this.stage.canvas.height / 2;

        this.bubleMC.x= this.stage.canvas.width/2;
        this.bubleMC.y= this.stage.canvas.height/2;
      }

    });
    this.requeimList = getRandomFamilyList();
    this.stage = new createjs.Stage("maincanvas");

    this.createDigits();
    if(this.animationState===AnimationState.BUBBLE)
      this.goToBuble();

    createjs.Ticker.addEventListener("tick", ()=>{
      this.updateDigits();

      if(this.animationState===AnimationState.LINES_DRAG){
        this.lineList.forEach((mtr,index)=>{
          const maxVis = this.lineList.length*(1-this.fadeCf);
          if(index>maxVis) {
            mtr.mc.line.rotation = Math.random();
            mtr.mc.line.y = Math.random() * 40;
          }else{
            mtr.mc.line.alpha = 0;
          }

        });
      }
    });
    createjs.Ticker.addEventListener("tick", this.stage);


  }

  getRandomLinePoint():number{
    const safeArea = (this.stage.canvas.height)/2;
    return safeArea*Math.random()+this.stage.canvas.height/4;
  }

  transferLines(){
    this.animationState = AnimationState.LINES_DRAG;
    this.lineList.forEach(mtr=>{
      mtr.mc.stop;
      this.lineContainer.removeChild(mtr.mc);
      mtr.mc.line.x=0;
      this.lineContainer.addChild(mtr.mc.line);
    })

    this.lineContainer.alpha = 1;
  }

  createLineAnimation(sY, eY, direction){

    const startY = sY-eY;
    const FRAMERATE = 25;
    let mc = new createjs.MovieClip({loop:0,framerate:FRAMERATE});
    const length = Math.sqrt(Math.pow(Math.abs(sY-eY),2)+Math.pow(this.stage.canvas.width,2));
    const line = (new createjs.Shape());
    line.graphics.beginStroke("#1c1c1c").setStrokeStyle(Math.floor(this.stage.canvas.height/75)).moveTo(-20, sY).lineTo(this.stage.canvas.width+20, eY);
    mc.line = line;

    mc.timeline.addTween(
      createjs.Tween.get(line)
        .to({x:(((direction)?-1:1)*this.stage.canvas.width),y:((direction)?1:-1)*startY})
        .to({x:0,y:0,alpha:1}, Math.floor(2.6*FRAMERATE))
        .to({x:0,y:0,alpha:0},Math.floor(60*2.6*FRAMERATE))
    );
    this.lineContainer.addChild(mc);
    return mc;
  }

  goToBuble(){
    this.lineList.forEach(mtr=>{
      mtr.mc.stop;
      this.lineContainer.removeChild(mtr.mc);
    })
    this.stage.removeChild(this.lineContainer);
    this.animationState = AnimationState.BUBBLE;
    this.bubleMC = this.createCircleMC(0);
    this.stage.addChild(this.bubleMC);
    this.bubleMC.gotoAndPlay(0);
  }

  gotoDigits(){
    this.animationState = AnimationState.DIGITS;
    this.bubleMC.stop();
    this.stage.removeChild(this.bubleMC);
    this.stage.addChild(this.digitsContainer);
  }

  goToDrag(){

  }

  updateDigits(){
    if(this.animationState===AnimationState.DIGITS){
      if(this.timeLeast>60)
        this.timeLeast = 60;
      const nulling = function(i){i.alpha=0};
      this.gDecDigits.forEach(nulling);
      this.gOneDigits.forEach(nulling);
      this.decDigits.forEach(nulling);
      this.oneDigits.forEach(nulling);
      if(this.timeLeast>=0) {
        const dec = Math.floor(this.timeLeast / 10);
        const dig = Math.floor(this.timeLeast % 10);
        const gDec = Math.floor((this.timeLeast + 1) / 10);
        const gDig = Math.floor((this.timeLeast + 1) % 10);

        if (this.timeLeast < 60) {
          this.gDecDigits[gDec].alpha = 0.3;
          this.gOneDigits[gDig].alpha = 0.3;
        }
        this.decDigits[dec].alpha = 1;
        this.oneDigits[dig].alpha = 1;
      }
    }
  }


  createDigits(){

    this.oneDigits.push(new createjs.Bitmap("0_.png"));
    this.oneDigits.push(new createjs.Bitmap("1_.png"));
    this.oneDigits.push(new createjs.Bitmap("2_.png"));
    this.oneDigits.push(new createjs.Bitmap("3_.png"));
    this.oneDigits.push(new createjs.Bitmap("4_.png"));
    this.oneDigits.push(new createjs.Bitmap("5_.png"));
    this.oneDigits.push(new createjs.Bitmap("6_.png"));
    this.oneDigits.push(new createjs.Bitmap("7_.png"));
    this.oneDigits.push(new createjs.Bitmap("8_.png"));
    this.oneDigits.push(new createjs.Bitmap("9_.png"));

    this.oneDigits.forEach(i=>{
      if(window.innerWidth>600) {
        i.scale= this.stage.canvas.height/1080;
        i.x = 10*i.scale;
        i.y = -272*i.scale;
      }else{
        i.x = 5;
        i.y = -136;
        i.scale= 0.5;
      }
      i.alpha=0;
      this.gOneDigits.push(i.clone());
    });

    this.decDigits.push(this.oneDigits[0].clone());
    this.decDigits.push(this.oneDigits[1].clone());
    this.decDigits.push(this.oneDigits[2].clone());
    this.decDigits.push(this.oneDigits[3].clone());
    this.decDigits.push(this.oneDigits[4].clone());
    this.decDigits.push(this.oneDigits[5].clone());
    this.decDigits.push(this.oneDigits[6].clone());
    this.decDigits.forEach(i=>{
      if(window.innerWidth>600)
        i.x = -336*i.scale;
      else
        i.x = -165;
      this.gDecDigits.push(i.clone());
    })
    this.digitsContainer = new createjs.Container();
    this.digitsContainer.x= this.stage.canvas.width/2;
    this.digitsContainer.y= this.stage.canvas.height/2;
    this.oneDigits.forEach(i=>{
      this.digitsContainer.addChild(i);
    })
    this.decDigits.forEach(i=>{
      this.digitsContainer.addChild(i);
    })
    this.gOneDigits.forEach(i=>{
      this.digitsContainer.addChild(i);
    })
    this.gDecDigits.forEach(i=>{
      this.digitsContainer.addChild(i);
    })
  }

  createCircleMC(dellay:number = 0){
    let mc = new createjs.MovieClip({loop:-1,framerate:12});
    mc.x= this.stage.canvas.width/2;
    mc.y= this.stage.canvas.height/2;
    mc.framerate = 24;
    mc.paused = true;

    const effectiveRadius = this.circleRadius*0.05;

    let child1 = new createjs.Shape(
      new createjs.Graphics().beginStroke("#fff").setStrokeStyle(effectiveRadius)
        .drawCircle(0,0,1));
    child1.alpha = 0;
    let child2 = new createjs.Shape(
      new createjs.Graphics().beginStroke("#fff").setStrokeStyle(effectiveRadius)
        .drawCircle(0,0,1));
    child2.alpha = 0;
    let firstRun=true;

    mc.timeline.addTween(
      createjs.Tween.get(child1)
        .to({alpha:1,radius:1}).to({alpha:0,radius:this.circleRadius}, 180).to({alpha:0,radius:1})
    ).addEventListener("change", (event) =>{
      event.target.target.graphics.clear().beginStroke("#1c1c1c").setStrokeStyle(effectiveRadius,1).drawCircle(0,0,event.target.target.radius);
    });


    return mc;
  }

  get circleRadius(){
    return (this.stage.canvas.width < this.stage.canvas.height)?this.stage.canvas.width/2:this.stage.canvas.height/2;
  }

  resizeCanvas(){
    const dpi = window.devicePixelRatio||1;
    (this.$refs['maincanvas'] as HTMLCanvasElement).width = window.innerWidth*dpi;
    (this.$refs['maincanvas'] as HTMLCanvasElement).height = window.innerHeight*dpi;
  }

  get currentRequiem(){
    return this.requeimList[this.requemIndex]||{};
  }

}
